import React, { useEffect, useState } from "react";
import "./Compass.css";

const CompassDirectionLabel = ({ degreeValue }) => {
  const [degree, setDegree] = useState(0);
  useEffect(() => {
    setDegree(degreeValue);
  }, [degreeValue]);

  const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "N"];

  const getDirection = (deg) => {
    const index = Math.round(deg / 45) % 8; // Each segment is 45 degrees
    return directions[index];
  };

  return <div className="direction-label">{getDirection(degree)}</div>;
};

export default CompassDirectionLabel;
